// extracted by mini-css-extract-plugin
export default {"fs_h3":"style_fs_h3__rP1sa","view_btn":"style_view_btn__2VgBX","table_wraper":"style_table_wraper__3hB7z"};